import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Context/AuthContext';

const InquiryList = () => {
  const { decodeS1 } = useAuth();
  const [page, setPage] = useState(1);
  const [select, setSelect] = useState(0);
  const [tab, setTab] = useState(1);
  const [title, setTitle] = useState('');
  const [inquiryList, setInquiryList] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const pageSize = 10; // 페이지당 항목 수
  const cate = 'inquiry';

  const [searchTerm, setSearchTerm] = useState(''); // 검색어
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const [searchOption, setSearchOption] = useState('연락처'); // 검색조건
  const [totalPages, setTotalPages] = useState(1); // 총 페이지 수
  const [totalItems, setTotalItems] = useState(''); // 총 게시글 수

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /**************************************************************/
  // 리스트 / 페이징처리
  /**************************************************************/
  useEffect(() => {
    getBoard();
  }, [cate, page]);

  const getBoard = () => {
    axios
      .get('https://ciuc.or.kr:8443/api/get/inquiry_search', {
        params: {
          page,
          pageSize,
          category: cate,
          searchTerm,
          searchOption,
        },
      })
      .then((res) => {
        const { totalItems, results } = res.data;
        setInquiryList(results);
        setTotalPages(Math.ceil(totalItems / pageSize));
        setTotalItems(totalItems);
      })
      .catch((error) => {
        console.error('리스트출력 오류', error);
      });
  };

  const hitCount = async (idx) => {
    try {
      await axios.post(`https://ciuc.or.kr:8443/api/post/board/inquiry/hit_count/${idx}`);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRowClick = (idx) => {
    const selectedItem = inquiryList.find((item) => item.idx === idx);
    if (selectedItem) {
      hitCount(idx);
      navigate(`/board/${cate}/${idx}`);
    }
  };

  const handleWrite = () => {
    navigate(`/board/${cate}/write`);
  };

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const handlePage = (num) => {
    setPage(num);
  };

  const handleTab = (num) => {
    setTab(num);
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  /**************************************************************/
  // 페이징 출력
  /**************************************************************/
  const renderPagination = () => {
    const pages = [];

    pages.push(
      <div key="prev" className="arrow_btn">
        <button
          className="page_button prev"
          onClick={() => handlePage(page - 1)}
          disabled={page <= 1 || totalItems === 0}
        >
          &lt;
        </button>
      </div>
    );

    const totalPagesToShow = totalPages === 0 ? 1 : totalPages;
    for (let i = 1; i <= totalPagesToShow; i++) {
      pages.push(
        <button
          type="button"
          key={i}
          className={`page_number ${page === i ? 'active' : ''}`}
          onClick={() => handlePage(i)}
          aria-current={page === i ? 'page' : undefined}
        >
          {i}
        </button>
      );
    }

    pages.push(
      <div key="next" className="arrow_btn">
        <button
          className="page_button next"
          onClick={() => handlePage(page + 1)}
          disabled={page >= totalPages || totalItems === 0}
        >
          &gt;
        </button>
      </div>
    );

    return pages;
  };

  /**************************************************************/
  // 검색
  /**************************************************************/
  const handleSearch = useCallback(async () => {
    try {
      const url = `https://ciuc.or.kr:8443/api/get/inquiry_search?page=${currentPage}&searchTerm=${searchTerm}&searchOption=${searchOption}&pageSize=${pageSize}&category=${cate}`;
      const res = await axios.get(url);
      const { totalItems, results } = res.data;
      const searchTotal = Math.ceil(totalItems / pageSize);

      setTotalPages(searchTotal);
      setTotalItems(totalItems);
      setInquiryList(results);
      setCurrentPage(1);
      setPage(1);
    } catch (error) {
      console.error('검색 결과 가져오기 오류:', error);
    }
  }, [searchTerm, searchOption, currentPage, pageSize, cate]);

  /**************************************************************/
  // 검색어 초기화
  /**************************************************************/
  const handleReset = useCallback(() => {
    setSearchTerm('');
    setSearchOption('연락처');
    setCurrentPage(1);
    getBoard();
  }, []);

  return (
    <div className="sub_wrap board">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area business-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}기업연구동{' > '}입주문의
            </div>
            <div className="banner_main_text">입주문의</div>
          </div>
        </div>

        {/* 상단 네비게이션 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업연구동</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>
            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">입주문의</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </div>
                <div className="select_row" onClick={() => movePage('/floor')}>
                  층별안내
                </div>
                <div className="select_row" onClick={() => movePage('/company')}>
                  입주기업현황
                </div>
                <div className="select_row" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 */}
        <div className="sub_main_area board">
          {/* 왼쪽 고정 사이드 메뉴 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              {' '}
              <div className="center_box">
                <span>기업연구동</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/inquiryinfo')}`} onClick={() => movePage('/inquiryinfo')}>
                <span>입주안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/floor')}`} onClick={() => movePage('/floor')}>
                <span>층별안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/company')}`} onClick={() => movePage('/company')}>
                <span>입주기업 현황</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/inquiry')}`}
                onClick={() => movePage('/board/inquiry')}
              >
                <span>입주문의</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 오른쪽 내용 영역 */}
          <div className="board_container-sub">
            {/* 제목 + 현재 경로 */}
            <div className="board_path_box">
              <div className="path_title">입주문의</div>
              <div className="path_navi">
                <span className="home_icon_small">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                    <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
                    <path
                      d="M2.5 12L12 3l9.5 9"
                      fill="none"
                      stroke="#cccccc"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="path_arrow">&gt;</span>
                <span>기업연구동</span>
                <span className="path_arrow">&gt;</span>
                <span className="current">입주문의</span>
              </div>
            </div>
            <div className="list_area">
              {/* 🔹 상단 : 총 건수 + 검색영역 */}
              <div className="list_top facility">
                <div className="board_info">
                  <div className="board_total_count">
                    총 <span className="count">{totalItems}</span>건&nbsp;
                    <span className="page_info">
                      ({page}/{totalPages === 0 ? 1 : totalPages} 페이지)
                    </span>
                  </div>
                </div>

                <div className="search_box">
                  {/* 셀렉트 */}
                  <select value={searchOption} onChange={(e) => setSearchOption(e.target.value)}>
                    <option value="연락처">연락처</option>
                  </select>

                  {/* 🔹 돋보기 + 인풋 랩 (CSS에서 기대하는 구조) */}
                  <div className="search_input_wrap">
                    <div className="search_icon" />
                    <input
                      className="search_input"
                      placeholder="검색어를 입력하세요"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  {/* 버튼 박스 */}
                  <div className="option-box">
                    <div className="search_btn" onClick={handleSearch}>
                      검색
                    </div>
                    <div className="reset-btn" onClick={handleReset}>
                      초기화
                    </div>
                  </div>
                </div>
              </div>

              {/* 🔹 리스트/테이블 */}
              <div className="list_box">
                {isMobile ? (
                  inquiryList.length > 0 ? (
                    inquiryList.map((item, index) => (
                      <div className="board-mobile" key={index} onClick={() => handleRowClick(item.idx)}>
                        <div className="mb-wrap">
                          <div className="mobile-sub">{item.title}</div>
                          <div className="mobile-btm">
                            <span>{item.writer}&nbsp;|&nbsp;</span>
                            <span>{item.date}&nbsp;|&nbsp;</span>
                            <span>조회수: {item.hit}</span>
                            {item.img1 == null ? '' : <span className="clip_icon"></span>}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no_data_mobile">
                      <div className="no-mobile-empty">
                        <div className="no-mobile-empty-icon">🔍</div>
                        <div className="no-mobile-empty-title">데이터가 존재하지 않습니다.</div>
                        <div className="no-mobile-empty-desc">
                          검색 조건을 다시 확인하거나 ‘초기화’ 버튼을 눌러 전체 목록을 확인해 주세요.
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <table className="board_table">
                    <thead className="table_head">
                      <tr className="head_row">
                        <th className="head_section num">번호</th>
                        <th className="head_section title">제목</th>
                        <th className="head_section">첨부파일</th>
                        <th className="head_section date">작성일시</th>
                      </tr>
                    </thead>
                    <tbody className="table_body">
                      {inquiryList.length === 0 ? (
                        <tr className="body_row no_table_data_row">
                          <td className="no_table_data" colSpan="4">
                            <div className="no-table-empty">
                              <div className="no-table-empty-icon">🔍</div>
                              <div className="no-table-empty-title">데이터가 존재하지 않습니다.</div>
                              <div className="no-table-empty-desc">
                                검색 조건을 다시 확인하거나 ‘초기화’ 버튼을 눌러 전체 목록을 확인해 주세요.
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        inquiryList.map((item, index) => {
                          const itemNumber = totalItems - ((page - 1) * pageSize + index);
                          return (
                            <tr className="body_row" key={index} onClick={() => handleRowClick(item.idx)}>
                              <td className="body_section num">{itemNumber}</td>
                              <td className="body_section title">{item.title}</td>
                              <td className="body_section file">
                                {item.img1 === null ? '' : <div className="clip_icon"></div>}
                              </td>
                              <td className="body_section date">{item.date}</td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                )}
              </div>

              {/* 🔹 글쓰기 버튼 */}
              <div className="write_box">
                <div className="write_btn" onClick={handleWrite}>
                  입주문의 등록
                </div>
              </div>

              <div className="pagination_box">{renderPagination()}</div>
            </div>
          </div>
          {/* board_container-sub 끝 */}
        </div>
        {/* sub_main_area 끝 */}
      </div>
    </div>
  );
};

export default InquiryList;
